import { oneOf } from 'prop-types';
import { padding, margin } from '../styles/spacing';
export var marginPropType = oneOf(Object.keys(margin));
export var paddingPropType = oneOf(Object.keys(padding));